var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNu = function SvgNu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 5.74v4.047L7.826 5.739H12ZM6.261 12h3.525L6.261 7.305l-.522 3.652L6.261 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.969 12H12v-.031l-.032.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 6.26V0h-.002C5.371.001 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M11.999 10.525 7.735 6.26H6.26l5.739 5.74v-1.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.07 1.565c-.462.263-.906.557-1.327.877h.492l-1.301.946.497 1.53-1.301-.946-.139.101c-.54.614-1.02 1.283-1.427 1.998V12h3.13V4.695H12v-3.13H6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.126 2.164c-.13.09-.257.184-.383.28l-.809.945-.804.585-.14.101c-.294.335-.57.686-.827 1.052a2.217 2.217 0 0 0 2.963-2.963Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m2.99 4.074.14-.102 1.301.946-.497-1.53 1.301-.946h-.492A12.075 12.075 0 0 0 2.99 4.074ZM8.295 2.087l.259.798h.838l-.678.492.259.797-.678-.492-.679.492.26-.797-.679-.492h.838l.26-.798ZM3.13 7.305l.26.797h.838l-.678.493.258.797L3.13 8.9l-.678.493.26-.797-.679-.493h.838l.26-.797Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNu;